exports.connect = {
	url: "https://api.camping-treguer-plage.camp/"
}
